export const BUILD_VERSION = typeof __APP_BUILD_VERSION__ !== 'undefined'
  ? __APP_BUILD_VERSION__
  : 'dev-runtime'

export const BUILD_TIME = typeof __APP_BUILD_TIME__ !== 'undefined'
  ? __APP_BUILD_TIME__
  : new Date(0).toISOString()

export const BUILD_GIT_SHA = typeof __APP_GIT_SHA__ !== 'undefined'
  ? __APP_GIT_SHA__
  : 'dev'

export default {
  BUILD_VERSION,
  BUILD_TIME,
  BUILD_GIT_SHA
}
